require('./bootstrap');

import Bugsnag from '@bugsnag/js'
import BugsnagPluginVue from '@bugsnag/plugin-vue'

Bugsnag.start({
  apiKey: process.env.MIX_BUGSNAG_API_KEY,
  plugins: [new BugsnagPluginVue()],
  enabledReleaseStages: ['production', 'staging'],
  releaseStage: process.env.NODE_ENV,
})

const bugsnagVue = Bugsnag.getPlugin('vue')

import { createApp, h } from 'vue';
import Navigation from '@components/Navigation/Navigation';
import HamburgerAndClose from '@components/Navigation/HamburgerAndClose';
import Logo from '@components/Logo';
import LogosCarousel from '@components/Carousels/LogosCarousel';

const app = createApp({
  //
  compilerOptions: {
    whitespace: 'condense',
    inheritAttrs: true,
  },

    data(){
      return {
        showing: false,
        mainNavEntries: window.mainNavEntries,
        mode: localStorage.getItem('theme','auto'),
      };
   },

  components: {
    Navigation,
    HamburgerAndClose,
    Logo,
    LogosCarousel,
  },

  mounted() {

        const rainbow = [
          '#F5CD4F',
          '#E8746F',
          '#8265B1',
          '#5CB4CA',
        ];

        let colorIndex = 0;
        document.addEventListener('selectstart', () => {
          colorIndex++;
          if (colorIndex >= rainbow.length) colorIndex = 0;
          document.querySelector('body').style.setProperty('--select-bg', `${rainbow[colorIndex]}`);
        });
  },
    methods: {
      setMode(mode) {
        this.mode = mode;
        localStorage.setItem('theme',mode);
        if (mode == 'dark') { document.documentElement.classList.add('dark'); return; }
        document.documentElement.classList.remove('dark');

      },
      removeMode() {
        this.mode = 'auto';
        if (!('theme' in localStorage) && window.matchMedia('(prefers-color-scheme: dark)').matches){
          document.documentElement.classList.remove('dark');
        }
        localStorage.removeItem('theme');
      },
      openNav() {
        this.showing = true;
      },
      closeNav() {
        setTimeout(() => {
          this.showing = false;
        }, 200);
      }
    }
  })
  .use(bugsnagVue)
  .mount('#app');

